// src/pages/CGV.js
import React from "react";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function CGV() {
  useSEO({
    title: "Conditions Générales de Vente — HLBK",
    description:
      "Conditions Générales de Vente applicables aux prestations photographiques proposées par HLBK.",
    canonical: "/cgv",
  });

  return (
    <section className="legal-page">
      <h1>Conditions Générales de Vente (CGV)</h1>

      <article className="legal-card">
        <h2>1 — Objet</h2>
        <p>
          Les présentes Conditions Générales de Vente (CGV) régissent les relations
          contractuelles entre HLBK, photographe professionnel indépendant, et
          toute personne physique ou morale faisant appel à ses services.
        </p>
      </article>

      <article className="legal-card">
        <h2>2 — Prestations</h2>
        <p>
          HLBK propose des prestations photographiques incluant notamment :
          portraits, mariages, événements privés ou professionnels, reportages
          et projets photographiques pour particuliers et entreprises.
        </p>
        <p>
          Le contenu précis de la prestation est défini dans le devis accepté
          par le client.
        </p>
      </article>

      <article className="legal-card">
        <h2>3 — Devis et commande</h2>
        <p>
          Toute prestation fait l’objet d’un devis détaillé, valable 30 jours à
          compter de sa date d’émission.
        </p>
        <p>
          La commande est considérée comme ferme et définitive à réception du
          devis signé, accompagné du versement d’un acompte si celui-ci est
          demandé.
        </p>
      </article>

      <article className="legal-card">
        <h2>4 — Tarifs et modalités de paiement</h2>
        <p>
          Les prix sont exprimés en euros. Pour les particuliers, ils sont
          indiqués TTC. Pour les entreprises, ils peuvent être indiqués HT.
        </p>
        <p>
          Les modalités de paiement (acompte, solde, échéances) sont précisées
          sur le devis. Le solde est exigible à la livraison des images, sauf
          mention contraire.
        </p>
        <p>
          Tout retard de paiement pourra entraîner des pénalités conformément à
          la législation en vigueur.
        </p>
      </article>

      <article className="legal-card">
        <h2>5 — Annulation et report</h2>
        <p>
          En cas d’annulation par le client, l’acompte versé reste acquis à HLBK
          à titre d’indemnité, sauf cas de force majeure.
        </p>
        <p>
          Un report de date peut être envisagé sous réserve de disponibilité et
          d’un accord écrit entre les parties.
        </p>
      </article>

      <article className="legal-card">
        <h2>6 — Réalisation de la prestation</h2>
        <p>
          HLBK s’engage à mettre en œuvre tous les moyens nécessaires pour livrer
          un travail professionnel conforme à son style et à sa démarche
          artistique.
        </p>
        <p>
          Le client reconnaît connaître le style photographique de HLBK et
          l’accepte sans réserve.
        </p>
      </article>

      <article className="legal-card">
        <h2>7 — Livraison des images</h2>
        <p>
          Les images sont livrées via une galerie privée en ligne ou tout autre
          moyen convenu, dans un délai communiqué au client à titre indicatif.
        </p>
        <p>
          Aucun fichier brut (RAW) ne sera remis.
        </p>
      </article>

      <article className="legal-card">
        <h2>8 — Propriété intellectuelle</h2>
        <p>
          Les photographies réalisées par HLBK demeurent protégées par le droit
          d’auteur, conformément au Code de la propriété intellectuelle.
        </p>
        <p>
          Sauf mention contraire, le client bénéficie d’un droit d’utilisation
          des images à des fins personnelles ou professionnelles, selon les
          usages définis dans le devis.
        </p>
        <p>
          Toute utilisation commerciale ou diffusion non prévue devra faire
          l’objet d’un accord écrit préalable.
        </p>
      </article>

      <article className="legal-card">
        <h2>9 — Responsabilités</h2>
        <p>
          HLBK ne pourra être tenu responsable des retards ou inexécutions dus à
          un cas de force majeure ou à des circonstances indépendantes de sa
          volonté.
        </p>
        <p>
          En cas de problème technique majeur empêchant la livraison des images,
          la responsabilité de HLBK sera limitée au remboursement des sommes
          versées.
        </p>
      </article>

      <article className="legal-card">
        <h2>10 — Données personnelles</h2>
        <p>
          Les informations personnelles collectées sont utilisées uniquement
          dans le cadre de la relation commerciale et ne sont jamais cédées à
          des tiers.
        </p>
        <p>
          Conformément au RGPD, le client peut exercer ses droits d’accès,
          rectification ou suppression en contactant HLBK.
        </p>
      </article>

      <article className="legal-card">
        <h2>11 — Droit applicable</h2>
        <p>
          Les présentes CGV sont soumises au droit français.
        </p>
        <p>
          En cas de litige, les parties s’efforceront de trouver une solution
          amiable avant toute action judiciaire.
        </p>
      </article>
    </section>
  );
}